import React from 'react'
import { skillTraitMapping, getExplanations } from './model'
import { getVisibleCategory, getReportCategoryKeys } from '../helpers'
import { t } from 'ttag'

export const useCompetencyState = ({
  project,
  language,
  response,
  selectedCompetency,
}) => {
  const categoryKeys = getReportCategoryKeys(project.profile)
  const explanations = getExplanations(categoryKeys, language)

  const visibleCategories = response?.map(resp => ({
    id: resp.id,
    scores: getVisibleCategory(categoryKeys, resp.scores, language),
  }))

  const radarData = visibleCategories
    ? visibleCategories.length === 1
      ? visibleCategories[0]?.scores
      : visibleCategories[0]?.scores.map((score, index) => ({
          ...score,
          score2: visibleCategories[1].scores[index].score,
        }))
    : []

  const getTraitScores = (selectedCompetency, scores) => {
    return skillTraitMapping[categoryKeys[selectedCompetency]]?.map(trait => ({
      score: scores[trait],
      label: trait,
    }))
  }

  const traitScores = response?.map(resp => ({
    id: resp.id,
    name: resp.name,
    scores: getTraitScores(selectedCompetency, resp.scores),
  }))

  const showRadar = visibleCategories[0].scores.length > 2

  const getScoreLabel = (visibleCategories, selectedCompetency) => {
    const scoreToLabel = {
      0: t`Low`,
      1: t`Low`,
      2: t`Normal`,
      3: t`High`,
      4: t`High`,
    }

    return scoreToLabel[visibleCategories[selectedCompetency]['score']]
  }

  return {
    state: {
      selectedCompetency,
      visibleCategories,
      showRadar,
      traitScores,
      explanations,
      radarData,
    },
    handlers: { getTraitScores, getScoreLabel },
  }
}
